import classNames from 'classnames';
// This is taken from palmetto components as it's needed for the AsyncSelect
import { FC, ReactNode } from 'react';

import styles from './InputValidationMessage.module.scss';

/**
 * Used by form inputs such as TextInput, to display a validation message for an invalid input.
 */

export interface InputValidationMessageProps {
  children: ReactNode;
  size?: 'xs' | 'sm' | 'md';
}

export const InputValidationMessage: FC<InputValidationMessageProps> = ({ children, size = 'sm' }) => {
  const classes = classNames(
    'palmetto-components__variables__form-control',
    styles['input-validation-message'],
    'font-color-danger',
    `font-size-${size}`,
    'm-top-xs',
  );

  return <div className={classes}>{children}</div>;
};
